import request from "@/utils/request";

export function getinfo(data) {
  return request({
    url: "/page-sign/get-info",
    method: "post",
    data
  });
}

export function savesig(data) {
  return request({
    url: "/page-sign/save-sig",
    //url: '/page-sign-dev/save-sig',
    method: "post",
    data
  });
}

export function signoffer(data) {
  return request({
    url: "/page-sign/sigoffer",
    //url: '/page-sign-dev/sigoffer',
    method: "post",
    data
  });
}

export function error(data) {
  return request({
    url: "/page-sign/error",
    method: "post",
    data
  });
}
